import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Util } from '@libs/utilities/util';
import { WebHelperService } from '@libs/libraries/frontend';
import { INgProductTour, NgProductTourService } from '@libs/frameworks/angular';

import { ProductTourUpload } from './data/upload-tour.data';
import { ProductTourResearch } from './data/research-tour.data';
import { StatesService } from '../../../../services/shared/states/states.service';
import { LOGO_LINKS, MASCOT_IMG_LINKS } from '../../../../../assets';
import { EnumWebAppTool } from '../../../constants/app.constant';
import { EnumInfoMessages } from '../../../../services/shared/local-storage/sub-storages/app.interface';
import { LocalStorageService } from '../../../../services/shared/local-storage/local-storage.service';
import { EnumResearchTourElement } from './data/research-tour.interface';


@Component({
    selector: 'app-welcome-tour',
    templateUrl: './welcome-tour.component.html',
    styleUrls: ['./welcome-tour.component.scss'],
    standalone: false
})
export class WelcomeTourComponent implements OnInit {

	//** Configuration */
	readonly LOGO_LINKS 	  : typeof LOGO_LINKS  		= LOGO_LINKS;
	readonly MASCOT_IMG_LINKS : typeof MASCOT_IMG_LINKS = MASCOT_IMG_LINKS;

	//** Getter Helpers */
	readonly EnumWebAppTool			: typeof EnumWebAppTool 		 = EnumWebAppTool;
	readonly EnumResearchTourElement: typeof EnumResearchTourElement = EnumResearchTourElement;

	//** Helper Variables */
	isDontShowAgainActive 	  : boolean = false;
	isResearchTourCompleted	  : boolean = false;
	isUploadTourCompleted	  : boolean = false;

	constructor(
		private activeModal 			: NgbActiveModal,
		private localStorageService 	: LocalStorageService,
		private webHelperService 		: WebHelperService,
		public  productTourResearch		: ProductTourResearch,
		public  productTourUpload		: ProductTourUpload,
		private productTourService 		: NgProductTourService,
		private statesService			: StatesService
	) {}


	/**------------------------------------------------------
	 * Live Cycle Hooks
	 */
	ngOnInit(): void {

		// check research & upload tour config data
		if (Util.Basic.isUndefined(this.productTourResearch?.PRODUCT_TOUR_RESEARCH)) throw new Error(`ProductTourComponent => ngOnInit => FATAL ERROR: PRODUCT_TOUR_RESEARCH data not found: ${typeof this.productTourResearch.PRODUCT_TOUR_RESEARCH}`);
		if (Util.Basic.isUndefined(this.productTourUpload?.PRODUCT_TOUR_UPLOAD)) 	 throw new Error(`ProductTourComponent => ngOnInit => FATAL ERROR: PRODUCT_TOUR_UPLOAD data not found: ${typeof this.productTourUpload.PRODUCT_TOUR_UPLOAD}`);
	}


	/**------------------------------------------------------
	 * Action Events
	 */
	dismissCloseModal(inputCheckBox: HTMLInputElement): void {

		//0 - save the boolean flag (Don't Show Again) in the local storage, to not to show again
		if (inputCheckBox.checked) this.localStorageService.app.disableInfoMessage(EnumInfoMessages.AppTour);

		//1 - close the modal
		this.closeModal();
	}


	//** Start Product Tour */
	startProductTour(productTour: INgProductTour, tool: string): void {

		//0 - check if right tool was selected, if not select it first before tour starts
		if (this.statesService.appState.getSelectedApp().tool !== tool) {

			// WORKAROUND: using js instead of angular way because for this single
			// > functionality we need to import the component and which breaks
			// > the flow of data and binding.
			this.webHelperService.clickElementById(EnumResearchTourElement.AppToggleBtn);
		}

		//1 - close the welcome modal and start product tour
		this.closeModal();
		this.productTourService.startTour(productTour);
	}

	//** Close Welcome Modal */
	closeModal(): void {
		this.activeModal.close();
	}
}
